import React, { useContext } from "react";
import { ProductContext } from "../../../stores/session";
import GenericDataRow from "../../../GenericPageElements/GenericDataRow";

export default function AdcSelect({ data, selectedAdcGroup, setSelectedAdcGrouup }) {
    const { translations, isWorkflow, adcGroups } = useContext(ProductContext)

    return (
        <GenericDataRow
            title={translations['ADC_Group']}
            contentColour={'var(--white)'}
            contentStyle={isWorkflow ? { padding: '0px' } : { backgroundColor: '#ececec', fontSize: '13px' }}
        >
            {
                isWorkflow ?
                    <select
                        style={{ border: 'none', width: '100%', outline: 'none' }}
                        onChange={(event) => setSelectedAdcGrouup(event.target.value)}
                        value={selectedAdcGroup}
                    >
                        <option value="">All ADC Groups</option>
                        {adcGroups.map(adcGroup => (
                            <option key={adcGroup} value={adcGroup}>
                                {adcGroup}
                            </option>
                        ))}
                    </select>
                    :
                    data.ADC_Group
            }
        </GenericDataRow>
    )
}